 /* globals urls, RSVP, KoisLoader */

 var $ = jQuery.noConflict();

// New class for Kois Unpaid Payments loader functionality
window.KoisUnpaidPayments = function(){
	KoisLoader.call( this );
	
	// Override properties as necessary
	this.validSections = ['unpaidPayments'];
	this.requestData = {
		action: 'fetch_unpaid_payment_sections'
	};
	this.sectionMappings = {
		unpaidPayments: {id: 'kois-upcoming-payments-contain'}
	};
};

// Inherit from KoisLoader class
KoisUnpaidPayments.prototype = Object.create( KoisLoader.prototype );
KoisUnpaidPayments.prototype.constructor = KoisUnpaidPayments;

// Override section event handler initialization function
KoisUnpaidPayments.prototype.initSectionEventHandlers = function(sectionContain, sectionName){
	var section =  $(sectionContain);
	// Future Payments Accordions
	section.find('.payment--details-expander').on('click', function(){
		var $panel = $(this).next('.payment--details.payment--schedule');
			if (!$panel.is(':visible')) {
				$(this).addClass('panel-open');
				$panel.slideDown();
			} else {
				$(this).removeClass('panel-open');
				$panel.slideUp();
			}
	});
	// Init popups
	$('body').trigger('initPopups', [sectionContain.selector]);
};